enum ModalDialogTypeEnum {
  Warning = 0,
  MailSuccess = 1,
  MailError = 2,
}

export default ModalDialogTypeEnum
